const heightsByAppId = new Map<string, number>();
const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((listener) => listener());
}

export function registerEmbeddedBottomChrome(appId: string, height: number): () => void {
  heightsByAppId.set(appId, height);
  notify();

  return () => {
    heightsByAppId.delete(appId);
    notify();
  };
}

export function subscribeEmbeddedBottomChrome(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function getEmbeddedBottomChrome(): number {
  let tallest = 0;
  heightsByAppId.forEach((height) => {
    tallest = Math.max(tallest, height);
  });

  return tallest;
}
